import { ILocation } from "@/Common/interfaces/location";
import VariableOperationsGpsBonus from "@/PayPlans/components/Commons/VariableOperationsGpsBonus";
import { IVariableOperationsGpsBonusSetup } from "@/PayPlans/types/sections/variableOperationsGpsBonus";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { EActionType, TAction } from "../../reducer";
import { TErrors } from "../../validation";

type GpsContentProps = {
	eligibilityRequirements: IVariableOperationsGpsBonusSetup;
	updateEligibilityRequirements: (updatedState: TAction) => void;
	errors: TErrors;
	useSectionsErrors?: () => any;
};

const ensureIds = (data: IVariableOperationsGpsBonusSetup): IVariableOperationsGpsBonusSetup => {
	return {
		...data,
		_id: data._id || uuidv4(),
		newVehicles: data.newVehicles.map((make) => ({
			...make,
			_id: make._id || uuidv4(),
		})),
		preOwned: {
			...data.preOwned,
			_id: data.preOwned._id || uuidv4(),
		},
		combined: {
			...data.combined,
			_id: data.combined._id || uuidv4(),
		},
	};
};

const GpsContent = (props: GpsContentProps) => {
	const { eligibilityRequirements, updateEligibilityRequirements, useSectionsErrors } = props;

	const location = useSelector((state: { location: { location: ILocation } }) => state.location.location);

	return (
		<VariableOperationsGpsBonus
			position="Sales Associate"
			onActionUpdate={(_section, _area, data) =>
				updateEligibilityRequirements({ type: EActionType.UPDATE_GPS_COMPLIANCE, payload: ensureIds(data) })
			}
			content={eligibilityRequirements}
			useSectionsErrors={useSectionsErrors}
			franchises={location?.franchises}
		/>
	);
};

export default GpsContent;
